/**
 * @file 
 * Provides some custom features for this shopify website.
 *
 */

/*============================================================================
  Global - Helper Functions
==============================================================================*/

var CC_Util = {

  isTablet: function() {
    if($(window).width() >= 768 && $(window).width() < 1024) {
      return true;
    }
  },

  isMobile: function() {
    if($(window).width() < 768) {
      return true;
    }
  }

}

/*============================================================================
  Global - Custom Inline Social Share 
==============================================================================*/

var cc_social_share = {

  // init: function(){
  //   cc_social_share.render_share_buttons();
  // },

  // render_share_buttons: function() {
  //   var page_title = encodeURIComponent($('h1:first').text());
  //   var page_url = window.location.href;
  //   var $button_container = $('.cc-social-share__icons');

  //   // Share URL's
  //   var pinterest_url = 'https://www.pinterest.com/pin/find/?url=' + page_url;
  //   var gplus_url = 'https://plus.google.com/share?url=' + page_url;
  //   var twitter_url = 'http://twitter.com/intent/tweet?text=' + page_title + ' - ' + page_url;
  //   var facebook_url = 'http://www.facebook.com/sharer/sharer.php?u=' + page_url;

  //   // Share btn map
  //   var social_share_buttons = {
  //     "pinterest": {
  //       "name": "Pinterest",
  //       "url": pinterest_url
  //     },
  //     "gplus": {
  //       "name": "Google+",
  //       "url": gplus_url
  //     },
  //     "twitter": {
  //       "name": "Twitter",
  //       "url": twitter_url
  //     },
  //     "facebook": {
  //       "name": "Facebook",
  //       "url": facebook_url
  //     },
  //   }

  //   // Create HTML for the buttons
  //   $.each(social_share_buttons, function(k,v){
  //     $button_container.prepend('<a target="_blank" class="cc-social-share-link ' + k + '" href="' + v.url + '"><span class="cc-social-share-icon"></span></a> ');
  //   });
  // },
}

/*============================================================================
  Global - Flipclock Countdown
==============================================================================*/

var cc_countdown_clock = {

  // init: function(){
  //   // Define the options
  //   var options = {
  //     dateFormat: "YYYY-MM-DD",   // The date input format.
  //     date: "2018-05-30",         // A date string, required.
  //     showYears: false,           // Toggles years
  //     showMonths: false,          // Toggles months
  //     showDays: true,             // Toggles days
  //     showHours: true,            // Toggles hours
  //     showMinutes: true,          // Toggles minutes
  //     showSeconds: true,          // Toggles seconds
  //     updateInterval: 1           // Seconds
  //   }

  //   $('#countdown-clock-target').countdownClock(options);
  // }

}

/*============================================================================
  Global - Collapse Text
==============================================================================*/

var cc_collapse_text = {
  init: function(){
    // var p_height = 45;
    if ( !CC_Util.isMobile() ) {
      if ($('.js-collapse-text').length > 0 && $('.js-collapse-text p').first().length) {
        p_height = jQuery('.js-collapse-text p').first().height();
        // Set height and add 'Read more' button
        jQuery('.js-collapse-text').css({'height':p_height,'overflow':'hidden'}).after('<div class="js-expand-btn"><span>Click this link to read more...</span></div>');
        // Add click function to 'Read more'
        $('.js-expand-btn span').on('click', function(event){
          $('.js-collapse-text').css({'height':'inherit'}).removeClass('js-collapse-text');
          $('.js-expand-btn').remove();
        });
      }
    }
  }
}

/*============================================================================
  Global - Product Description/Delivery Tabs
==============================================================================*/

var cc_product_tabs = {

  init: function(){

    // First check if it's the product page
    if (!$('body.product').length) {
      return;
    }

    // First hide all the sections except for 'description'
    $('.js-product-section').not('div[data-sectionname="description"]').hide();

    // Setup the click event on the product tabs
    $('.js-product-tab').on('click', function(event) {
      $visible_section = $('.js-product-section:visible').attr('data-sectionname');
      $clicked_tab_name = $(event.currentTarget).attr('data-tabname');

      if ($clicked_tab_name != $visible_section) {
        // Toggle OFF previous tabs/sections
        $('.js-product-section:visible').hide();
        $('span[data-tabname="'+$visible_section+'"').removeClass('product-detail-tabs__tab--active');
        // Toggle ON new tabs/sections
        $('span[data-tabname="'+$clicked_tab_name+'"').addClass('product-detail-tabs__tab--active');
        $('div[data-sectionname="'+$clicked_tab_name+'"').show();
      }
    });

  }

}

/*============================================================================
  Global - Collapse Filter Menu 
==============================================================================*/

var cc_mobile_filter_menu = {

  // init: function(){

  //   if (CC_Util.isMobile()) {
  //     $('.sidebar .filter-menu').hide();
  //     $('.collection_description').hide();
  //   }
  // },

}

/*============================================================================
  Global - Height Helper Text on Traditional 'Product Details'
==============================================================================*/

var cc_product_details_helper_text = {

  default_text: ' <br/><strong><em>NOTE: This is the height without the pendulum, weights and chains. ',
  one_day_text: 'Typically for 1-day cuckoo clocks it is best to accomodate for a "hanging chain length" of about 1.5 metres below the clock.</em></strong>',
  eight_day_text: 'Typically for 8-day cuckoo clocks it is best to accomodate for a "hanging chain length" of about 1.8 metres below the clock.</em></strong>',

  init: function() {
    // First detect if page is 'Traditional 1-day or 8-day' and thus needs a description added to 
    // say that the clock height does not inlcude the height of the chains, pendulum and weights.
    var $product = $('.product-template-section div[data-product-tag]');

    if ($product.length <= 0) {
      return;
    }

    var $product_tags = $product.attr('data-product-tag');
    var is_type_one_day = $product_tags.indexOf('1-day-movement') !== -1;
    var is_type_eight_day = $product_tags.indexOf('8-day-movement') !== -1;

    if (!is_type_one_day && !is_type_eight_day) {
      // If it isn't 1-day or 8-day then don't do anything
      return;
    }

    // Get TD with height string 
    $height_td = $('.js-product-section table td:contains("Size (height):")').next('td');
    // Add the correct text
    updated_text = $height_td.html() + this.default_text;

    if (is_type_one_day) {
      updated_text = updated_text + this.one_day_text;
    } 

    if (is_type_eight_day) {
      updated_text = updated_text + this.eight_day_text;
    }

    $height_td.html(updated_text);

  }

}

/*============================================================================
  Global - Custom features added by Ryan
==============================================================================*/

$(function() {
  // Renders the flipclock countdown timer
  // cc_countdown_clock.init();
  // Collapse text
  cc_collapse_text.init();
  // Renders Description and Delivery in tabs on product pages
  cc_product_tabs.init();
  // Add helper text to table with traditional cuckoo clock height
  cc_product_details_helper_text.init();
  // Collapses the sidebar Filter menu on mobile
  // cc_mobile_filter_menu.init();
  // Renders custom social share buttons to a page when 'cc_social_share' string is added in WYSIWYG
  // cc_social_share.init();
});
